import { styled } from '@mui/material/styles';

export const Icon = styled('img')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: 25,
  height: 25,
}));
